// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import CalculationTotals from './totals';
import ClaimSpecialAllowanceCalculation from '@deere/cps-it.warranty-model-factory/lib/claim-special-allowance-calculation';
import FormValidation from '../../state/form-validation';
import {FormattedMessage} from 'react-intl';
import LabeledCurrency from '../../../../shared/components/labeled-currency';
import LabeledCurrencyInput from '../../../shared/components/claim-fields/labeled-currency-input';
import SpaClaim from '@deere/cps-it.warranty-model-factory/lib/claim-special-allowance';

function handleInputBlur(property) {

    const value = this.specialAllowanceCalculations.companyContribution ?
        this.specialAllowanceCalculations.companyContribution : null;

    this.actions.updateSpaClaimInputOnBlur(property, value);

}

function handleClaimPropertyChange(property, value) {

    this.actions.updateSpaClaimCalculationProperty(property, value);

}

function isConstributionDisabledForSpaType(type) {

    return type === '12';

}

const CalculationPanel = props =>
    <section className='special-allowance-calculation'>
        <header>
            <FormattedMessage id='SPECIAL_ALLOWANCE_CALCULATION'/>
            <span className='currency'>
                {`(${props.specialAllowanceCalculations.currency.value})`}
            </span>
        </header>
        <LabeledCurrencyInput
            allowNegative={false}
            className='customer-contribution'
            decimalPrecision={2}
            disabled={isConstributionDisabledForSpaType(props.claim.specialAllowanceType.key)}
            isEditable={props.isEditable}
            isValid={true}
            label='CUSTOMER_CONTRIBUTION'
            onChange={handleClaimPropertyChange.bind(props, 'customerContribution')}
            value={props.specialAllowanceCalculations.customerContribution}
        />
        <LabeledCurrencyInput
            allowNegative={false}
            className='dealer-contribution'
            decimalPrecision={2}
            disabled={isConstributionDisabledForSpaType(props.claim.specialAllowanceType.key)}
            isEditable={props.isEditable}
            isValid={true}
            label='DEALER_CONTRIBUTION'
            onChange={handleClaimPropertyChange.bind(props, 'dealerContribution')}
            value={props.specialAllowanceCalculations.dealerContribution}
        />
        <LabeledCurrencyInput
            allowNegative={false}
            className='company-contribution'
            decimalPrecision={2}
            disabled={isConstributionDisabledForSpaType(props.claim.specialAllowanceType.key)}
            errorMessage='COMPANY_CONTRIBUTION_IS_REQUIRED'
            isEditable={props.isEditable}
            isValid={props.formValidation.companyContribution}
            label='COMPANY_CONTRIBUTION'
            onBlur={handleInputBlur.bind(props, 'companyContribution')}
            onChange={handleClaimPropertyChange.bind(props, 'companyContribution')}
            value={props.specialAllowanceCalculations.companyContribution}
        />
        <LabeledCurrency
            className='total-contribution'
            data={props.specialAllowanceCalculations.contributionTotal}
            label='TOTAL_CONTRIBUTION'
        />
        <CalculationTotals
            allowedActions={props.claim.allowedActions}
            claimNumber={props.claim.claimNumber}
            showAmountsInLocalCurrency={props.showAmountsInLocalCurrency}
            values={props.specialAllowanceCalculations}
        />
    </section>;

CalculationPanel.displayName = 'CalculationPanel';
CalculationPanel.propTypes = {
    actions: PropTypes.object.isRequired,
    claim: PropTypes.instanceOf(SpaClaim).isRequired,
    formValidation: PropTypes.instanceOf(FormValidation).isRequired,
    isEditable: PropTypes.bool.isRequired,
    showAmountsInLocalCurrency: PropTypes.bool.isRequired,
    specialAllowanceCalculations: PropTypes.instanceOf(ClaimSpecialAllowanceCalculation).isRequired
};

export default CalculationPanel;



// WEBPACK FOOTER //
// ./src/claim/spa/components/calculation-panel/calculation-container.js